import React, { useRef, useState } from 'react';
import { FiX, FiPaperclip, FiUploadCloud, FiExternalLink } from 'react-icons/fi';
import { uploadArquivoGenerico, abrirArquivo } from '../../../../services/arquivos';
import { salvarAnexoProcesso } from '../../../../services/etapas';
import styles from '../Onboard.module.css';
import useEsc from '../../../../hooks/useEsc';

function AnexoModal({ proc, lead, onFechar, onSalvo }) {
  useEsc(onFechar);
  const inputRef             = useRef(null);
  const [arquivo,     setArquivo]     = useState(null);
  const [uploading,   setUploading]   = useState(false);
  const [abrindo,     setAbrindo]     = useState(false);
  const [erro,        setErro]        = useState('');

  const temAnexo = !!proc.anexo_url;

  function handleEscolherArquivo(e) {
    const f = e.target.files?.[0];
    if (f) { setArquivo(f); setErro(''); }
  }

  async function handleUpload() {
    if (!arquivo) return setErro('Selecione um arquivo para enviar.');
    setUploading(true);
    setErro('');
    try {
      const { url, nome } = await uploadArquivoGenerico(arquivo, `onboard/${lead.id}`);

      await salvarAnexoProcesso(proc.id, {
        anexo_url:  url,
        anexo_nome: nome,
      });

      onSalvo(proc.id, { anexo_url: url, anexo_nome: nome });
    } catch (e) {
      setErro(e.message);
    } finally {
      setUploading(false);
    }
  }

  /* anexo_url agora é um caminho interno (não mais uma URL pública do
     Supabase Storage) -- abrir precisa passar pelo backend autenticado */
  async function handleAbrirAnexo() {
    setAbrindo(true);
    try {
      await abrirArquivo(proc.anexo_url, proc.anexo_nome);
    } catch (e) {
      setErro(e.message);
    } finally {
      setAbrindo(false);
    }
  }

  return (
    <div
      className={styles.registroOverlay}
    >
      <div className={styles.registroModal}>

        {/* Header */}
        <div className={styles.registroHeader}>
          <FiPaperclip size={16} className={styles.registroHeaderIcon} />
          <div>
            <p className={styles.registroTitulo}>Documento Anexado</p>
            <p className={styles.registroSubtitulo}>{proc.titulo}</p>
          </div>
          <button className={styles.btnFechar} onClick={onFechar} style={{ marginLeft: 'auto' }}>
            <FiX size={16} />
          </button>
        </div>

        <div className={styles.registroForm}>

          {/* Anexo atual */}
          {temAnexo && (
            <div className={styles.anexoAtual}>
              <FiPaperclip size={14} className={styles.anexoAtualIcon} />
              <span className={styles.anexoAtualNome}>{proc.anexo_nome || 'Documento'}</span>
              <button
                type="button"
                onClick={handleAbrirAnexo}
                disabled={abrindo}
                className={styles.anexoBtnVer}
                title="Abrir documento"
              >
                <FiExternalLink size={13} />
              </button>
            </div>
          )}

          {/* Área de upload */}
          <div
            className={styles.anexoDropArea}
            onClick={() => inputRef.current?.click()}
          >
            <FiUploadCloud size={28} className={styles.anexoDropIcon} />
            <p className={styles.anexoDropTexto}>
              {arquivo
                ? arquivo.name
                : temAnexo
                  ? 'Clique para substituir o documento'
                  : 'Clique para selecionar o documento'}
            </p>
            {arquivo && (
              <p className={styles.anexoDropTamanho}>
                {(arquivo.size / 1024).toFixed(0)} KB
              </p>
            )}
            <input
              ref={inputRef}
              type="file"
              style={{ display: 'none' }}
              onChange={handleEscolherArquivo}
              accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
            />
          </div>

          {erro && <p className={styles.registroErro}>{erro}</p>}
        </div>

        {/* Footer */}
        <div className={styles.registroFooter}>
          <button
            className={styles.registroBtnCancelar}
            onClick={onFechar}
            disabled={uploading}
          >
            Fechar
          </button>
          <button
            className={styles.registroBtnSalvar}
            onClick={handleUpload}
            disabled={uploading || !arquivo}
          >
            {uploading ? 'Enviando...' : temAnexo ? 'Substituir' : 'Enviar Documento'}
          </button>
        </div>

      </div>
    </div>
  );
}

export default AnexoModal;
